import Swal from 'sweetalert2';
import { ADMIN_ROLE, SUPERADMIN_ROLE } from '@/helpers/CONSTANTS';

const ALLOWED = [ADMIN_ROLE, SUPERADMIN_ROLE];

/**
 * Guard de rutas /manual-payment/*. Solo ADMIN y SUPERADMIN pueden acceder a
 * los pagos manuales. Si el rol no esta permitido, muestra un toast/modal y
 * redirige al home.
 */
export const manualPaymentGuard = (to, from, next) => {
  let role = '';

  try {
    role = JSON.parse(localStorage.getItem('user')).user.role.name;
  } catch (error) {
    role = '';
  }

  if (!ALLOWED.includes(role)) {
    Swal.fire({
      title: 'Acceso restringido',
      text: 'Solo ADMIN o SUPERADMIN pueden acceder a los pagos manuales.',
      icon: 'warning',
      confirmButtonText: 'Entendido',
    });
    return next({ name: 'home' });
  }

  return next();
};
